import React from 'react';
import PropTypes from 'prop-types';
import {AgGridReact as Grid} from "ag-grid-react";
import styled from 'styled-components';
import {DateRenderer, PrimaryButton, WarningButton} from '../../../components';
import {bindActionCreators} from "redux";
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import * as actions from '../period.actions';
import * as applicationActions from '../../../application.actions';


const Container = styled.div`
    width: 100%;
    height: 600px;
`;

export class PeriodGrid extends React.PureComponent {
  api = null;
  state = {
    columns: {
      description: {
        headerName: "Period",
        field: "description"
      },
      dueDate: {
        headerName: "Due Date",
        field: "dueDate",
        cellRenderer: "dateRenderer"
      },
      status: {
        headerName: this.props.roles.admin ? 'Period Status' : 'Upload Status',
        show: this.props.show,
        cellRenderer: "statusRenderer"
      },
      actions: {
        headerName: "Actions",
        roles: this.props.roles,
        type: "actionsColumn",
        cellRenderer: "actionsRenderer"
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.api && this.props.data !== nextProps.data) {
      this.api.refreshCells();
    }
    if(this.props.roles !== nextProps.roles){
      this.setState(st => ({
        ...st,
        columns: {
          ...st.columns,
          status: {
            ...st.columns.status,
            headerName: nextProps.roles.admin ? 'Period Status' : 'Upload Status'
          }
        }
      }))
    }
  }

  onGridReady = ({api}) => {
    this.api = api;
    api.sizeColumnsToFit();
    api.setFilterModel(this.props.gridFilterModel);
    api.setSortModel(this.props.gridSortModel);
    api.paginationGoToPage(this.props.currentPage);
  }

  onFilterChanged = ({api}) => this.props.actions.gridFilterChanged(api.getFilterModel());
  onSortChanged = ({api}) => this.props.actions.gridSortChanged(api.getSortModel());
  onPaginationChanged = ({api}) => this.props.actions.gridPaginationChanged(api.paginationGetCurrentPage());

  gridActions = history => ({data}) => {
    const {roles} = this.props;
    const admin = roles.admin;
    const nfHasAccess = roles.nursingFacility && data.facilityStatus.value > 1;

    const isComplete = roles.nursingFacility ?
                       data.facilityStatus.value === 4 :
                       data.quarterlyStatusValue === 3;

    const Button = isComplete ? PrimaryButton : WarningButton;
    const text = isComplete ? 'View' : 'Edit';

    return admin || nfHasAccess ?
           <Button onClick={() => history.push(`/period/${data.id}`)}>{text} </Button>
                                : null;
  };

  statusRenderer = ({data}) => {
    return this.props.roles.admin ? data.quarterlyStatus : data.facilityStatus.name;
  };

  render() {
    const {data, show} = this.props;
    console.log('columns', this.state.columns.status.headerName);

    return show ? (
      <Container className='ag-fresh'>
        <Grid
          onPaginationChanged={this.onPaginationChanged}
          onFilterChanged={this.onFilterChanged}
          onSortChanged={this.onSortChanged}
          rowData={data}
          onGridReady={this.onGridReady}
          paginationPageSize={10}
          pagination={true}
          enableFilter={true}
          enableSorting={true}
          suppressMovableColumns={true}
          headerHeight={35}
          rowHeight={35}
          enableColResize={true}
          columnDefs={Object.values(this.state.columns)}
          defaultColDef={{filterParams: {newRowsAction: 'keep'}}}
          columnTypes={{
            actionsColumn: {suppressMenu: true, suppressSorting: true}
          }}
          frameworkComponents={{
            actionsRenderer: this.gridActions(this.props.history),
            statusRenderer: this.statusRenderer,
            dateRenderer: DateRenderer
          }}
         />
      </Container>
    ) : null
  }
}

PeriodGrid.propTypes = {
  show: PropTypes.bool,
  data: PropTypes.array.isRequired,
  roles: PropTypes.shape({
    admin: PropTypes.bool.isRequired,
    nursingFacility: PropTypes.bool.isRequired,
  }).isRequired,
  gridFilterModel: PropTypes.array,
  gridSortModel: PropTypes.array
};

export default withRouter(
    connect(
    (state) => ({
      gridFilterModel: state.periods.grid.filterModel,
      gridSortModel: state.periods.grid.sortModel,
      currentPage: state.periods.grid.currentPage
    }),
    (dispatch) => ({actions: bindActionCreators({...applicationActions, ...actions}, dispatch)})
  )(PeriodGrid)
);


// WEBPACK FOOTER //
// ./src/modules/periods/components/PeriodGrid.js